import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSuitcaseSticker"><Path fillRule="evenodd" clipRule="evenodd" d="M17 2H7V6H2V21H22V6H17V2ZM15.5 6H8.5V3.5H15.5V6ZM10.7283 10.0927L5.8634 11.8634L6.93023 14.7945L11.7951 13.0238L10.7283 10.0927ZM17.9999 14.5C17.9999 15.8807 16.8807 17 15.4999 17C14.1192 17 12.9999 15.8807 12.9999 14.5C12.9999 13.1193 14.1192 12 15.4999 12L17.9999 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcaseSticker;
